<app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
  [contentTableArray]="contentTableArray" [content_Details]="content_Details" (closecontentpopup)="closecontentpopup()"
  [tablevalues]="tablevalues" [tablekeys]="tablekeys">
</app-contentpopup>
<p *ngIf="ShowLmsMessage != ''" style="color: red; font-weight: bold; text-align: center; text-decoration: underline;">
  {{ ShowLmsMessage }}
</p>
<table class="table table-bordered" id="excel-table">
  <div class="table-responsive">
    <thead *ngIf="!this.paramsValues.section">
      <tr>
        <th *ngIf="showCheckBox" style="text-align: center;">Select</th>
        <th></th>
        <th>
          <i class="fa fa-edit icons" (click)="editbtn()"></i>
          <i class="fa fa-download icons" title="Dowload file" (click)="downloadFiles()"></i>
          <i class="fa fa-check-square icons" title="Download upon selection" (click)="downloadSelected()"></i>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let Obj of DragData | Object2keyvalue; let index=index"
        [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }">
        <td *ngIf="showCheckBox"><input type="checkbox" style="margin-left: 2.5rem;"
            (click)="selected_checbox(Obj.key, index)" /></td>
        <td #headerids
          [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }"
          [ngClass]="[getcolorcode(Obj.key,DragData.colorindicator)]">
          {{Obj.key}}
          <span class="tooltip-container">
            <i class="fas fa-info-circle info-icon"></i>
            <div class="custom-tooltip" [innerHTML]="getTooltipContent(Obj.key)"></div>
          </span>
          <div class="action-buttons">
            <button pButton [label]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'Verified' : 'Verify'"
              class="custom-button verify-btn" (click)="verifyField(Obj.key)"
              [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true"
              [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'not-allowed' : 'pointer' }">
            </button>

            <button pButton
              [label]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'Under Review' : 'Review'"
              class="custom-button review-btn" (click)="openReviewDialog(Obj.key)"
              [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true"
              [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'not-allowed' : 'pointer' }">
            </button>
          </div>
        </td>
        <td>
          <div *ngIf="Obj.value | arrayChk;else displayvalue;let is=index">
            <div *ngIf="Obj.value | tableChk;else list">
              <div class="table-responsive">
                <table class="table table-bordered" id="innertable">
                  <thead style="font-size: 12px;">
                    <tr>
                      <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader">
                        <p>{{headers}}</p>
                        <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
                      </th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 10px;">
                    <tr *ngFor="let trows of Obj.value | tableBody ;let m=index">
                      <td *ngFor="let rdata of trows;let iindex =index">
                        <div [ngClass]="[showedit ? 'editcls' : 'editdisable']">
                          <ng-container *ngIf="(Obj.value | tableHeaders)[iindex] === 'Description'; else defaultInput">
                            <ckeditor [editor]="Editor" [ngModel]="rdata"
                              (ngModelChange)="editdata($event, Obj.value, Obj.key, trows, rdata, Obj, m, Obj.key,'rdata', iindex)">
                            </ckeditor>
                          </ng-container>
                          <ng-template #defaultInput>
                            <input type="text"
                              (change)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                              [ngClass]="[rdata.length>=20?'input-size':'']" value={{rdata}} id={{rdata}} />
                          </ng-template>
                        </div>
                        <div [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']">
                          <span *ngIf="(Obj.value | tableHeaders)[iindex] === 'Description'; else defaultText"
                            [innerHTML]="sanitizeHtml(rdata)"></span>
                          <ng-template #defaultText>
                            {{Obj.key === 'Dosage and Administration' || Obj.key === 'Recommended dose' || Obj.key ===
                            'Food effect' || Obj.key === 'Indications and Usage' ||Obj.key === 'Variability (%
                            ISCV)'||Obj.key === 'PK Linearity'||Obj.key === 'Pharmacology'? '': rdata}}
                          </ng-template>
                        </div>
                      </td>
                      <i *ngIf="Obj.value.length > 1 && showedit" [ngClass]="['editcls']"
                        style="font-size: 20px; cursor: pointer; margin: 10px;" class="fas fa-trash float-left"
                        (click)="deleteRow(Obj.value, m)">
                      </i>
                    </tr>

                    <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;margin-top: 10px;"
                      *ngIf="Obj.key ==='Filed ANDA'" class="fas fa-plus float-left"
                      (click)="addListItem(Obj.value,Obj,Obj,m,Obj.key)"></i>
                    <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;margin-top: 10px;"
                      *ngIf="Obj.key !=='Filed ANDA'" class="fas fa-plus float-left"
                      (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)"></i>
                    <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                      *ngIf="Obj.value.length>sliceEnd" class="btn btn-success"
                      (click)="showLess(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show More</button> -->
                    <button [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 15px;
                      margin-left: 35px;
                      margin-top: 10px;" (click)="deleteTable(Obj.key)">
                      Delete Table
                    </button>
                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #list>
              <ul>

                <li *ngFor="let lItems of Obj.value;let inds=index">
                  <p [ngClass]="[showedit?'editcls':'editdisable']">
                    <!-- <input type="text" [ngClass]="[lItems.length>=20?'input-size':'']" (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" value={{lItems}} /> -->
                    <textarea [ngClass]="[lItems.length>=20?'input-size':'']"
                      (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" style="height: 30px;"
                      value={{lItems}} cols="30" rows="10"></textarea>
                    <i *ngIf="Obj.value.length > 1 && inds > 0" class="fas fa-trash"
                      style="font-size: 20px; cursor: pointer; margin-left: 10px;"
                      (click)="deleteListItem(Obj.value, Obj.key, inds)"></i>
                  </p>
                  <p [ngClass]="[!showedit?'editcls':'editdisable']">

                    {{lItems}}

                  </p>

                </li>
                <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                  class="fas fa-plus float-left" (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key)"></i>
                <div style="display: flex; align-items: center;">
                  <button [ngClass]="[showedit?'editcls':'editdisable']" style="margin-left: 35px;"
                    (click)="addTable(Obj.value,lItems,Obj,m,Obj.key)">Add Table</button>
                  <button [ngClass]="[showedit ? 'editcls' : 'editdisable']" style="margin-left: 15px;"
                    (click)="replaceWithNA(Obj.value, Obj.key)">Replace with N/A</button>
                </div>
                <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                  *ngIf="Obj.key !== 'Dosage and Administration' && Obj.key !== 'Recommended dose' &&  Obj.key !== 'Indications and Usage' && Obj.value.length>5"
                  class="btn btn-success" (click)="showArray(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                  More</button> -->

              </ul>
            </ng-template>
          </div>
          <ng-template #displayvalue>
            <ng-container
              *ngIf="['Additional comments on Competitive Intelligence', 'Comment (if any)','Peak Sale Insights'].includes(Obj.key)">
              <div [ngClass]="[showedit ? 'editcls' : 'editdisable']">
                <ckeditor [editor]="Editor" [ngModel]="Obj.value"
                  (ngModelChange)="editdata($event, Obj.value, Obj.key, index, '')">
                </ckeditor>
              </div>
              <div class="editor-content" style="margin-bottom: 10px;">
                <p [ngClass]="[showedit ? 'editdisable' : 'editcls']" [innerHTML]="sanitizeHtml(Obj.value)">
                </p>
              </div>
            </ng-container>

            <ng-container
              *ngIf="!['Additional comments on Competitive Intelligence', 'Comment (if any)','Peak Sale Insights'].includes(Obj.key)">
              <p
                [ngClass]="[showedit && Obj.key !== 'FDA label' && Obj.key !== 'FDA product specific BE guidance' ? 'editcls' : 'editdisable']">
                <input type="text" [ngClass]="[Obj.value?.length >= 20 ? 'input-size' : '']" value="{{Obj.value}}"
                  (change)="editdata($event, Obj.value, Obj.key, index, '')" />
              </p>
              <p
                [ngClass]="[!showedit && Obj.key !== 'FDA label' && Obj.key !== 'FDA product specific BE guidance' ? 'editcls' : 'editdisable']">
                {{ Obj.value }}
              </p>
            </ng-container>

            <!-- <p
              [ngClass]="[showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
              <input type="text" [ngClass]="[Obj.value?.length>=20?'input-size':'']" value={{Obj.value}}
                (change)="editdata($event,Obj.value,Obj.key,index,'')" />
            </p>
            <p
              [ngClass]="[!showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
              {{Obj.value}}

            </p> -->

            <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;" class="fas fa-plus float-left"
              (click)="addListItem(Obj.value, Obj.key, Obj, Obj, Obj.key)"></i>
            <button [ngClass]="[showedit?'editcls':'editdisable']" style="margin-left: 35px;"
              (click)="addTable(Obj.value,lItems,Obj,m,Obj.key)">Add Table</button>

            <i [ngClass]="[ Obj.key ==='FDA label' && Obj.value !== 'N/A'?'editcls':'editdisable']"
              (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
            <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
              (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
            <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div>
            <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div>
          </ng-template>

          <div *ngFor="let edited of isChanged(Obj.key)">
            <div *ngIf="edited === Obj.key" [id]="Obj.key">
              <i class="fa fa-check" title="Accept" (click)="handelAction(Obj,'accept')"
                style="cursor: pointer;color:#2bc44e;padding-left:1rem;"></i>
              <i class="fa fa-remove" title="Reject" (click)="handelAction(Obj,'reject')"
                style="cursor: pointer;padding-left:3rem;color:red"></i>
            </div>
          </div>

        </td>

      </tr>
      <tr>
        <td *ngIf="showCheckBox">
          <button class="btn btn-primary" (click)="downloadSelectedData()">Download</button>
        </td>
      </tr>
    </tbody>

    <!-- BRAND DETAILS ROW - inside main table tbody, before </tbody> -->
    <tr>
      <td *ngIf="showCheckBox"></td>
      <td class="brand-details-label">
        PharSights Verified Sales ($ Mn)
        <div *ngIf="brandDetailsTableData?.[0]?.currencyRate" class="currency-rate">
          {{ brandDetailsTableData[0]?.currencyRate }}
        </div>
      </td>
      <td>
        <div class="table-responsive">
          <table class="table table-bordered" id="innertable">
            <thead style="font-size: 12px;">
              <tr>
                <th>Year</th>
                <th>Currency {{ brandDetailsTableData?.[0]?.currencyTypeText }}</th>
                <th>Jan-Mar</th>
                <th>Apr-Jun</th>
                <th>Half Year Total</th>
                <th>Jul-Sep</th>
                <th>Oct-Dec</th>
                <th>Full Year Total</th>
              </tr>
            </thead>
            <tbody style="font-size: 10px;">
              <ng-container *ngIf="brandDetailsTableData?.length; else noDataRow">
                <tr *ngFor="let row of brandDetailsTableData">
                  <td>{{ row.years }}</td>
                  <td>{{ row.currencyDisplay }}</td>
                  <td>
                    {{ row.q1 }}
                    <div *ngIf="row.currency !== 'USD'" class="text-muted">$ {{ row.q1_Converted }} (Mns)</div>
                  </td>
                  <td>
                    {{ row.q2 }}
                    <div *ngIf="row.currency !== 'USD'" class="text-muted">$ {{ row.q2_Converted }} (Mns)</div>
                  </td>
                  <td>
                    {{ row.halfYearTotal }}
                    <div *ngIf="row.currency !== 'USD'" class="text-muted">$ {{ row.halfYearTotal_Converted }} (Mns)
                    </div>
                  </td>
                  <td>
                    {{ row.q3 }}
                    <div *ngIf="row.currency !== 'USD'" class="text-muted">$ {{ row.q3_Converted }} (Mns)</div>
                  </td>
                  <td>
                    {{ row.q4 }}
                    <div *ngIf="row.currency !== 'USD'" class="text-muted">$ {{ row.q4_Converted }} (Mns)</div>
                  </td>
                  <td>
                    {{ row.fullYearTotal }}
                    <div *ngIf="row.currency !== 'USD'" class="text-muted">$ {{ row.fullYearTotal_Converted }} (Mns)
                    </div>
                  </td>
                </tr>
              </ng-container>

              <ng-template #noDataRow>
                <tr>
                  <td colspan="9" style="text-align: left; padding: 6px 10px;">
                    No Data Available
                  </td>
                </tr>
              </ng-template>

            </tbody>
          </table>
          <p>Final Comment: {{ brandDetailsTableData[0]?.finalComment }}</p>
        </div>
      </td>
    </tr>

  </div>
</table>

<p-dialog header="Review Entry" [(visible)]="displayReviewDialog" [modal]="true" [closable]="false"
  class="custom-dialog">
  <div class="dialog-content">
    <div class="p-field">
      <label for="email">Select Email:</label>
      <p-dropdown [options]="emailList" [(ngModel)]="selectedEmail" placeholder="Select Email">
      </p-dropdown>
      <div *ngIf="submitted && !selectedEmail" class="error-text">
        Email is required.
      </div>
    </div>

    <div class="p-field">
      <label for="key">Key Name:</label>
      <input id="key" type="text" pInputText [(ngModel)]="selectedKey" readonly class="readonly-input">
    </div>

    <div class="p-field">
      <label for="comment">Comment:</label>
      <textarea id="comment" pInputTextarea [(ngModel)]="reviewComment" rows="2" cols="40"
        class="comment-box"></textarea>
      <small class="comment-warning">
        {{ reviewComment.length < 15 ? 'Minimum 15 characters required.' : '&nbsp;' }} </small>
    </div>
  </div>

  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Cancel" class="cancel-btn"
      (click)="displayReviewDialog = false"></button>
    <button type="button" pButton icon="pi pi-check" label="Submit" class="submit-btn" [disabled]="!isCommentValid()"
      (click)="submitReview()"></button>
  </p-footer>
</p-dialog>
<div *ngIf="showedit" class="text-center">
  <button class="btn btn-primary" (click)="saveEdit()">Save</button>
</div>